import React from 'react'
import { DragDropContext, Droppable, Sensor } from 'react-beautiful-dnd'
import { DraggableRow } from './DraggableRow'
import { reorder } from '../../utils'
import { info } from '../../services/sentryLogger'

export interface DraggableItemIF<T> {
    id: string
    index: number
    title: string
    renderedComponent?: any // custom child
    data: T // anything that will not be visually rendered
    disabled?: boolean
}

interface OwnProps<T> {
    id?: string
    items: DraggableItemIF<T>[]
    onChange: (newItems: DraggableItemIF<T>[]) => void
    onDelete?: (idToDelete: string) => void
    registerAutomation?: {
        registerHeight: (height: number) => void
        registerSensor: Sensor
        registerEnd: () => void
    }
}

const getListStyle = (isDraggingOver: any) => ({
    // background: isDraggingOver ? "lightblue" : "lightgrey",
    // padding: grid,
    width: '100%',
})

export const DraggableList = <T,>(p: OwnProps<T>) => {
    // info('DraggableList', { p })
    const { registerHeight, registerSensor, registerEnd } =
        p.registerAutomation ?? {}

    const onDragEnd = (result: any) => {
        info('DraggableList onDragEnd', { result })
        if (!result.destination) {
            return
        }

        const items = reorder(
            p.items,
            result.source.index,
            result.destination.index
        )

        p.onChange(items as DraggableItemIF<T>[])
        registerEnd && registerEnd()
    }

    return (
        <div
            // fixed
            // disableGutters
            style={{
                zIndex: 999,
                width: '100%',
                maxHeight: '50vh',
                overflowY: 'scroll',
                backgroundColor: 'white',
            }}
        >
            <DragDropContext
                enableDefaultSensors
                sensors={registerSensor ? [registerSensor] : undefined}
                onDragEnd={onDragEnd}
            >
                <Droppable droppableId={p.id || 'droppable'}>
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={(ref) => {
                                provided.innerRef(ref)
                                // hRef.current = ref;
                            }}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {p.items.map(({ id, index, ...rest }, i) => (
                                <DraggableRow
                                    registerHeight={registerHeight}
                                    key={id}
                                    id={id}
                                    index={index}
                                    {...rest}
                                    onDelete={() =>
                                        p.onDelete && p.onDelete(id)
                                    }
                                />
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    )
}
